import React from "react";

import styles from "./doc-set.module.scss";

const DocSetMenu = ({ children }) => {
  return <ul className={styles.container}> {children}</ul>;
};

export default DocSetMenu;